export const IS_LOADING_FORM_AUTH = 'IS_LOADING_FORM_AUTH';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const TOKEN_TYPE = 'TOKEN_TYPE';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const EXPIRES_AT = 'EXPIRES_AT';
